import { useNavigate } from "react-router-dom";
import "./BlogCard.scss";
import { baseUrl } from "../../../../utils/apiData";

const BlogCard = ({ data }) => {
  const navigate = useNavigate();

  return (
    <div
      className="blog_card wow fadeInUp"
      onClick={() => navigate(`/blog/${data?.slug}`)}
    >
      <div className="img_wrap">
        <img src={`${baseUrl}/${data?.image}`} alt="blog" />
      </div>
      <div className="text">
        <p className="t-12">{data?.subtitle || "-"}</p>
        <h4>{data?.name || "-"}</h4>
        <p>{data?.small_description || "-"}</p>
      </div>
    </div>
  );
};

export default BlogCard;
